module.exports = __webpack_public_path__ + "static/media/9.05bf100a.jpg";